// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"cdba2b2d","455":"623a6b41","977":"f1b37dec"}[chunkId] + ".chunk.js";
};